import React, { Component } from 'react'

import Breadcrumbs from '../block/Breadcrumbs'
import Sotrudnichestvo from '../block/Sotrudnichestvo'
import About from '../block/About'
import Stati from '../block/Stati'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <Breadcrumbs breadcrumbs={data?.breadcrumbs || []} />
        <Sotrudnichestvo data={data} />
        <About data={data} />
        <Stati data={data} />
      </>
    )
  }
}

export default App